import type { AvatarChangeResult, PasswordChangeDto, PasswordChangedDto, UserProfileDto } from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';

/** E04 — GET /users/me */
export async function getMe(): Promise<UserProfileDto> {
  const { data } = await apiClient.get<UserProfileDto>('/users/me');
  return data;
}

/** E33 — POST /users/me/password. Returns a fresh access token for the caller's own session. */
export async function postChangePassword(body: PasswordChangeDto): Promise<PasswordChangedDto> {
  const { data } = await apiClient.post<PasswordChangedDto>('/users/me/password', body);
  return data;
}

/** E34 — PUT /users/me/avatar (multipart, field `file`). 429 `AVATAR_CHANGE_COOLDOWN` carries `nextChangeAt`. */
export async function putMyAvatar(file: File): Promise<AvatarChangeResult> {
  const body = new FormData();
  body.append('file', file, file.name || 'avatar.jpg');
  const { data } = await apiClient.put<AvatarChangeResult>('/users/me/avatar', body);
  return data;
}

/** E35 — GET /users/me/avatar: the caller's own photo as a Blob (authenticated; there is no public URL). */
export async function getMyAvatarBlob(): Promise<Blob> {
  const { data } = await apiClient.get<Blob>('/users/me/avatar', { responseType: 'blob' });
  return data;
}
